import React, {
  FC,
  useContext,
  useState,
  useEffect,
} from "react";
import { useDataValue } from "./form/utils";
import { FormContext } from "./form/FormContext";
import { FormControl } from "./form/components/FormControl";
import { createStyles, makeStyles } from "@material-ui/styles";
import { Button, OutlinedInput, Theme } from "@material-ui/core";

const useStyles = makeStyles(function (theme: Theme) {
  return createStyles({
    text: function () {
      return {
        padding: "12px",
        backgroundColor: theme.palette.grey[100],
        color: theme.palette.text.primary,
      };
    },
    jsonInput: {
      width: "100%",
    },
    jsonSubmit: {
      margin: "0 0 0 auto",
      display: "flex",
    },
  });
});

export const JsonPreview: FC<{}> = function (props) {
  const { onSetData } = useContext(FormContext);
  const dataPath = '{}';
  const officialValue = useDataValue(dataPath);
  const [text, setText] = useState("");
  const [json, setJSON] = useState("");

  useEffect(
    function updateFromSource() {
      setText(
        "" +
          (officialValue !== undefined && officialValue !== null
            ? JSON.stringify(officialValue, null, 2)
            : "")
      );
    },
    [officialValue]
  );

  const classes = useStyles();

  return (
    <FormControl>
      <div className={classes.text}>
        <pre>{text}</pre>
      </div>
      <br />
      <div className={classes.text}>
        <OutlinedInput
          className={classes.jsonInput}
          onChange={(e) => setJSON(e.target.value)}
          multiline={true}
          rows="25"
        />
        <Button
          className={classes.jsonSubmit}
          onClick={() => {
            onSetData(dataPath, "", JSON.parse(json));
          }}
          disabled={!json}
        >
          Set JSON
        </Button>
      </div>
    </FormControl>
  );
};
